import { resetPassword } from "../auth_store.js";
import { authLayout, field, btnPrimary, alertBox, bindForm } from "./auth_shell.js";
import { navigate } from "../router.js";
import { t } from "../i18n.js";

function tokenFromHash() {
  const hash = window.location.hash;
  const q = hash.indexOf("?");
  if (q < 0) return "";
  return new URLSearchParams(hash.slice(q + 1)).get("token") ?? "";
}

export function renderResetPassword(root) {
  const token = tokenFromHash();
  if (!token) {
    root.innerHTML = authLayout({
      title: t("Invalid link"),
      subtitle: t("This password reset link is missing or expired."),
      childrenHtml: alertBox(t("Request a new reset link from the sign-in page.")),
      footerHtml: `<a class="portal-link" href="#/forgot-password">${t("Request reset link")}</a>`,
    });
    return;
  }

  root.innerHTML = authLayout({
    title: t("Choose new password"),
    subtitle: t("Use at least 8 characters with a mix of letters and numbers."),
    childrenHtml: `
      <div id="reset-alert"></div>
      <form class="portal-form" novalidate>
        ${field({ id: "password", label: t("New password"), type: "password", placeholder: "••••••••", autocomplete: "new-password" })}
        ${field({ id: "confirm", label: t("Confirm password"), type: "password", placeholder: "••••••••", autocomplete: "new-password" })}
        ${btnPrimary(t("Update password"), { type: "submit" })}
      </form>
    `,
    footerHtml: `<a class="portal-link" href="#/login">${t("← Back to sign in")}</a>`,
  });

  bindForm(root, (values) => {
    const alertEl = root.querySelector("#reset-alert");
    if (values.password !== values.confirm) {
      alertEl.innerHTML = alertBox(t("Passwords do not match."));
      return;
    }
    const res = resetPassword(token, values.password);
    if (!res.ok) {
      alertEl.innerHTML = alertBox(t(res.error));
      return;
    }
    navigate("/dashboard", true);
  });
}
